"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _usePresenterStandaloneContext = require("./usePresenterStandaloneContext");
Object.keys(_usePresenterStandaloneContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePresenterStandaloneContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePresenterStandaloneContext[key];
    }
  });
});